import React from 'react'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles'
import ModalThemeProvider from './ModalThemeProvider'

const RequestErrorModal = props => (
    <ModalThemeProvider>
        <Typography variant="display1"
            align="center"
            paragraph>
            {`解析失败了( >﹏<。)`}
        </Typography>
        <Typography variant="body2"
            align="center"
            paragraph>
            要不刷新重试一下？
        </Typography>
        <Button variant="raised"
            color="secondary"
            className={props.classes.button}
            fullWidth
            onClick={() => props.onClick()}>
            OK
        </Button>
    </ModalThemeProvider>
)

export default withStyles()(RequestErrorModal)


// WEBPACK FOOTER //
// ./src/components/modals/requestError.js